!<template>
  <div id="footer">

    <a href="https://www.akinhwan.com">
    <img id="me" :src="require('@/assets/tc-crop-purple.png')" alt="akinhwan.com">
    </a>
    <a href="https://www.akinhwan.com">Made by akinhwan</a>
    <!-- CTA content -->
    <div class="">
      <p class="join">Join my weekly newsletter of curated links and for updates on what I'm
        working on. <a href="https://www.akinhwan.com/newsletter/#archive">View the archives here.</a></p>
    </div>



    <div class="emailoctopus-form-wrapper emailoctopus-form-default emailoctopus-form-wrapper-large"
      style="font-family: Arial, Helvetica Neue, Helvetica, sans-serif; color: rgb(26, 26, 26);">

      <form action="https://emailoctopus.com/lists/625955a8-4616-11eb-a3d0-06b4694bee2a/members/embedded/1.3/add"
        method="post" data-message-success="Thanks for subscribing!"
        data-message-missing-email-address="Your email address is required."
        data-message-invalid-email-address="Your email address looks incorrect, please try again."
        data-message-bot-submission-error="This doesn't look like a human submission."
        data-message-consent-required="Please check the checkbox to indicate your consent."
        data-message-invalid-parameters-error="This form has missing or invalid fields."
        data-message-unknown-error="Sorry, an unknown error has occurred. Please try again later."
        class="emailoctopus-form">
        <div class="emailoctopus-form-row">
          <label for="field_0">
            Email address
          </label>
          <input id="field_0" name="field_0" type="email" placeholder="Email Address" required="required">
        </div>
        <div aria-hidden="true" class="emailoctopus-form-row-hp">
          <input type="text" name="hpc4b27b6e-eb38-11e9-be00-06b4694bee2a" tabindex="-1" autocomplete="nope">
        </div>
        <div class="emailoctopus-form-row-subscribe">
          <input type="hidden" name="successRedirectUrl">
          <button type="submit" class="subscribe"
            style="display: flex; margin: auto; background-color: rgb(75, 74, 207); color: rgb(255, 255, 255); font-family: IBM Plex Mono;">
            Subscribe
          </button>
        </div>
      </form>
      <p class="emailoctopus-success-message">
      </p>
      <p class="emailoctopus-error-message">
      </p>
    </div>

  </div>
</template>

<script>
  export default {
    mounted() {
      let emailOctopus = document.createElement('script')
      emailOctopus.setAttribute('src', 'https://emailoctopus.com/bundles/emailoctopuslist/js/1.6/form-embed.js')
      document.head.appendChild(emailOctopus)
    }
  }
</script>

<style lang="scss" scoped>
  #footer {
    text-align: center;
    display: flex;
    flex-direction: column;

    #me {
      border-radius: 50%;
      width: 30%;
      max-width: 10rem;
      margin: auto;
      padding-bottom: 2rem;
    }

    .join {
      color: white;
    }

    a {
      color: white;
    }

    #field_0 {
      width: 100%;
      font-size: 1rem;
      padding: 1rem;
    }

    .emailoctopus-success-message,
    .emailoctopus-failure-message {
      color: white;
      font-family: 'IBM Plex Mono', monospace;
    }

    .subscribe {
      max-width: 27rem;
      justify-content: center;
      width: 100%;
      padding: 1rem;
    }
  }
</style>